export default "__VITE_ASSET__ea5fc965__"